<h6>Status per member</h6>
<!---Item for loop in on line 3 to 36 rest is for testing an presentations only-->
<div *ngFor="let mem of statuschart | slice:0:6" class="card bg-secondary p-2 pl-1 pr-1" style="margin-bottom:6px;">
    <div class="row">
        <div class="col-2">
            <app-personimage [enableChange]="false" [bigimg]="false" [listtype]="true" [personId]="mem.personId"  class="rounded-circle"></app-personimage>
        </div>
        <div class="col-4 pl-0">
            <p class="mb-0 lh-30 align-middle text-truncate">{{mem.name}}</p>
        </div>
        <div class="col-2">
            <div class="row">
                <span class="material-icons c-save align-middle cursor-default lh-30 ">
                    recommend
                    </span>
                <p class="mb-0 lh-30 c-save font-weight-bold align-middle">{{mem.ontime}}</p>
            </div>
        </div>
        <div class="col-2">
            <div class="row">
                <span class="material-icons c-almost align-middle cursor-default lh-30 ">
                    error
                    </span>
                <p class="mb-0 lh-30 c-almost font-weight-bold align-middle">{{mem.almost}}</p>
            </div>
        </div>       
        <div class="col-2">
            <div class="row">
                <span class="material-icons c-close align-middle cursor-default lh-30 ">
                    whatshot
                    </span>
                <p class="mb-0 lh-30 font-weight-bold c-close align-middle">{{mem.overdue}}</p>
            </div>
        </div>
    </div>
</div>